import React from 'react';
import {connect} from 'react-redux';
import _ from 'underscore';

import {BenchlingState} from 'redux-stores/reduceApp';
import {BenchlingDispatch} from 'redux-stores/Store';

import {
  changeHoverIndex,
  hoverOption,
  testOnlyOpenAllSubmenus,
  updateMenuSelectableOptions,
} from './MenuReduxActions';
import {MenuState, MenuStateSelector} from './reduceMenusUI';

interface WrapperState {
  cid: string;
}

function mapStateToProps(state: BenchlingState, props: WrapperState): MenuState {
  return new MenuStateSelector(state).getMenuState(props.cid);
}

interface DispatchProps {
  onUpdateSelectableIndices: (selectableIndices: Array<number>) => void;
  onChangeHoverIndex: (newHoverIndex: number) => number;
  onHoverOption: (selectableIndex: number) => void;
  /** for testing only */
  testOnlySetOpenAllSubmenus: (openAllSubmenus: boolean) => void;
}

export type ConnectedMenuProps = MenuState & DispatchProps;

function mapDispatchToProps(dispatch: BenchlingDispatch, props: WrapperState): DispatchProps {
  return {
    onUpdateSelectableIndices: (selectableIndices: Array<number>) => {
      dispatch(updateMenuSelectableOptions(props.cid, selectableIndices));
    },
    onChangeHoverIndex: (newHoverIndex: number) => dispatch(changeHoverIndex(props.cid, newHoverIndex)),
    onHoverOption: (selectableIndex: number) => {
      dispatch(hoverOption(props.cid, selectableIndex));
    },
    testOnlySetOpenAllSubmenus: (isOpenAllSubmenus: boolean) => {
      dispatch(testOnlyOpenAllSubmenus(props.cid, isOpenAllSubmenus));
    },
  };
}

/**
 * Wrapper component to render a menu-rendering component with navigation state.
 *
 * Generates a CID for the menu component, and connects it to store state and actions.
 */
export default function withMenuNavigationLoading<P>(
  WrappedComponent: React.ComponentType<P & ConnectedMenuProps>
): React.ComponentClass<P> {
  const ConnectedWrappedComponent: React.ComponentType<P & WrapperState> = connect<
    MenuState,
    DispatchProps,
    P & WrapperState
  >(
    mapStateToProps,
    mapDispatchToProps
    // @ts-expect-error
  )(WrappedComponent) as React.ComponentType<P & WrapperState>;

  class Component extends React.Component<P, WrapperState> {
    private _cid: string = _.uniqueId('menuCid');

    render(): JSX.Element {
      return <ConnectedWrappedComponent cid={this._cid} {...this.props} />;
    }
  }
  return Component;
}
